
import { Component, Prop, Vue } from 'vue-property-decorator';
import { BackupServerDto } from '@/services/Backup/interfaces/index';

@Component
export default class DeleteBackupServerDialog extends Vue {
  @Prop()
  public readonly backupServer!: BackupServerDto;

  public visible: boolean = true;

  get message(): string {
    return `Are you sure you want to remove Backup Server: #${this.backupServer.id}?`;
  }

  public async deleteBackupServer(): Promise<void> {
    this.$emit('delete', this.backupServer);
    this.destroyComponent();
  }

  public destroyComponent(): void {
    this.$emit('close');
  }
}
